import React from 'react';
import IdentifyPage from 'researcher/application/components/IdentifyPage';
import featureEnabled from 'shared/helper/feature';
import DigitalOrdersAlert from './DigitalOrdersAlert';
import OrderRestorationMessage from './OrderRestorationMessage';
import Orders from './Orders';
import UnpaidInvoices from './UnpaidInvoices';
import Widgets from './Widgets';
var Dashboard = function Dashboard(_ref) {
  var addMessage = _ref.addMessage,
    addPreferredGroup = _ref.addPreferredGroup,
    companyShortName = _ref.companyShortName,
    fetchOrders = _ref.fetchOrders,
    getDownloadUrl = _ref.getDownloadUrl,
    digitalOrdersLinkTerm = _ref.digitalOrdersLinkTerm,
    history = _ref.history,
    orderFormInProgress = _ref.orderFormInProgress,
    pagination = _ref.pagination,
    pathname = _ref.pathname,
    removePreferredGroup = _ref.removePreferredGroup,
    searchParams = _ref.searchParams,
    status = _ref.status,
    orders = _ref.orders,
    unpaidInvoices = _ref.unpaidInvoices,
    updateCertificate = _ref.updateCertificate,
    user = _ref.user;
  var curieLaunched = featureEnabled('curie_is_launched');
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IdentifyPage, {
    title: "Researcher home"
  }), /*#__PURE__*/React.createElement("div", {
    className: "dashboard-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container container-outer"
  }, !curieLaunched && /*#__PURE__*/React.createElement(DigitalOrdersAlert, {
    digitalOrdersLinkTerm: digitalOrdersLinkTerm
  }), /*#__PURE__*/React.createElement(OrderRestorationMessage, {
    orderFormInProgress: orderFormInProgress
  }), /*#__PURE__*/React.createElement(UnpaidInvoices, {
    currency: user.currency,
    hideInvoices: user.hideInvoices,
    unpaidInvoices: unpaidInvoices
  }), /*#__PURE__*/React.createElement(Orders, {
    addMessage: addMessage,
    displayInvoices: !user.hideInvoices,
    fetchOrders: fetchOrders,
    getDownloadUrl: getDownloadUrl,
    history: history,
    pagination: pagination,
    pathname: pathname,
    searchParams: searchParams,
    status: status,
    orders: orders,
    updateCertificate: updateCertificate
  }), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(Widgets, {
    addPreferredGroup: addPreferredGroup,
    removePreferredGroup: removePreferredGroup,
    companyShortName: companyShortName,
    orders: orders,
    user: user
  }))));
};
export default Dashboard;